import { ChangeDetectionStrategy, Component, Input, OnInit, ViewChild } from '@angular/core';
import { MatMenu } from '@angular/material/menu';
import { LcsCellDefDirective, LcsColumnDefDirective, LcsHeaderCellDefDirective } from '@lcs/shared/table';

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: 'ndt-actions-column-def',
    templateUrl: './actions-column-def.component.html',
    standalone: false
})
export class ActionsColumnDefComponent<T> implements OnInit {
   @Input() getId: (index: number, data: T) => string;

   @Input() label = 'Row Actions';

   @Input() showColumnContent = true;

   @Input() menu: MatMenu;

   @ViewChild(LcsCellDefDirective, { static: true }) cellDef: LcsCellDefDirective;

   @ViewChild(LcsColumnDefDirective, { static: true }) columnDef: LcsColumnDefDirective;

   @ViewChild(LcsHeaderCellDefDirective, { static: true }) headerCellDef: LcsHeaderCellDefDirective;

   ngOnInit(): void {
      this.getId ??= this.getIndexId;
      this.columnDef.cell = this.cellDef;
      this.columnDef.headerCell = this.headerCellDef;
   }

   private getIndexId(index: number, _: T) {
      return `${index}-row-action-button`;
   }
}
